exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fullscreen__fullscreen-button__2wW-_{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon__2OybO{opacity:1}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-exit-fullscreen__sSUHt,.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-fullscreen__1oUz3{display:none}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-exit-fullscreen-hover__2IzWE,.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-fullscreen-hover__1S9hL{display:block}.fullscreen__icon__2OybO{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;opacity:.8}.fullscreen__icon-exit-fullscreen-hover__2IzWE,.fullscreen__icon-fullscreen-hover__1S9hL{display:none}.fullscreen__icon-fullscreen__1oUz3{font-size:15px}.fullscreen__icon-fullscreen-hover__1S9hL{font-size:17px}.fullscreen__icon-exit-fullscreen-hover__2IzWE{font-size:21px}.fullscreen__icon-exit-fullscreen__sSUHt{font-size:25px}", ""]);

// exports
exports.locals = {
	"fullscreen-button": "fullscreen__fullscreen-button__2wW-_",
	"fullscreenButton": "fullscreen__fullscreen-button__2wW-_",
	"icon": "fullscreen__icon__2OybO",
	"icon-exit-fullscreen": "fullscreen__icon-exit-fullscreen__sSUHt",
	"iconExitFullscreen": "fullscreen__icon-exit-fullscreen__sSUHt",
	"icon-fullscreen": "fullscreen__icon-fullscreen__1oUz3",
	"iconFullscreen": "fullscreen__icon-fullscreen__1oUz3",
	"icon-exit-fullscreen-hover": "fullscreen__icon-exit-fullscreen-hover__2IzWE",
	"iconExitFullscreenHover": "fullscreen__icon-exit-fullscreen-hover__2IzWE",
	"icon-fullscreen-hover": "fullscreen__icon-fullscreen-hover__1S9hL",
	"iconFullscreenHover": "fullscreen__icon-fullscreen-hover__1S9hL"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/controls/fullscreen/fullscreen.styl
// module id = 1304
// module chunks = 0 1 2 3